export const TRUCKNET_DOMAIN = "trucknet.io";

export const isTrucknetDomain = () => {
  const regex = new RegExp(TRUCKNET_DOMAIN);

  return regex.test(window.location.hostname);
};



// WEBPACK FOOTER //
// ./src/trucknetDomain.js